import { render } from "./DebugIndicator.vue?vue&type=template&id=782782a0&scoped=true"
import script from "./DebugIndicator.vue?vue&type=script&lang=js"
export * from "./DebugIndicator.vue?vue&type=script&lang=js"

import "./DebugIndicator.vue?vue&type=style&index=0&id=782782a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782782a0"]])

export default __exports__